import React, { useState } from "react";
import axios from "axios";
import { Link, useSearchParams } from "react-router-dom";
import Icon from "./Icons";

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async event => {
    event.preventDefault();
    setError("");

    if (password.length < 8) {
      setError("Use at least 8 characters for your new password.");
      return;
    }
    if (password !== confirmPassword) {
      setError("The passwords do not match.");
      return;
    }

    setLoading(true);
    try {
      await axios.post("/api/user/reset-password", { token, password });
      setSuccess(true);
    } catch (requestError) {
      setError(requestError.response?.data?.message || "We could not reset your password. Please request a new link.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-[calc(100vh-4rem)] items-center justify-center px-5 py-14">
      <div className="w-full max-w-md">
        <p className="sc-kicker mb-3">New password</p>
        <h1 className="font-serif text-4xl font-semibold tracking-[-0.03em] text-cream">Turn the page.</h1>
        <p className="mt-2 text-sm leading-relaxed text-cream-muted">Choose a new password for your StoryChats account.</p>

        <div className="sc-panel mt-8 p-6 sm:p-7">
          {!token ? (
            <div className="text-center">
              <p className="font-serif text-2xl text-cream">Missing reset link</p>
              <p className="mt-2 text-sm text-cream-muted">Request a fresh password reset link to continue.</p>
              <Link to="/forgot-password" className="sc-btn-gold mt-6 w-full no-underline">Request new link</Link>
            </div>
          ) : success ? (
            <div className="text-center">
              <span className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-gold/10 text-gold"><Icon name="sparkle" size={20} /></span>
              <h2 className="font-serif text-2xl text-cream">Password updated</h2>
              <p className="mt-2 text-sm text-cream-muted">You can now return to your library with your new password.</p>
              <Link to="/login" className="sc-btn-gold mt-6 w-full no-underline">Sign in <Icon name="arrow" size={15} /></Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-5">
              {error && <div className="rounded-xl border border-crimson/30 bg-crimson/10 px-4 py-3 text-sm text-crimson-light">{error}</div>}
              <div>
                <label className="mb-1.5 block text-xs font-medium text-cream-dim" htmlFor="new-password">New password</label>
                <input id="new-password" type="password" value={password} onChange={event => setPassword(event.target.value)} placeholder="At least 8 characters" className="sc-input" required autoFocus />
              </div>
              <div>
                <label className="mb-1.5 block text-xs font-medium text-cream-dim" htmlFor="confirm-password">Confirm new password</label>
                <input id="confirm-password" type="password" value={confirmPassword} onChange={event => setConfirmPassword(event.target.value)} placeholder="Repeat your password" className="sc-input" required />
              </div>
              <button type="submit" disabled={loading} className="sc-btn-gold w-full py-3 disabled:opacity-50">
                {loading ? "Updating password…" : "Update password"}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
